import { render, staticRenderFns } from "./CharacterSheetExperience.vue?vue&type=template&id=d7645ba4&lang=pug&"
import script from "./CharacterSheetExperience.vue?vue&type=script&lang=ts&"
export * from "./CharacterSheetExperience.vue?vue&type=script&lang=ts&"
import style0 from "./CharacterSheetExperience.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBadge,VBtn,VChip,VIcon,VProgressLinear})
